export const METHOD_LIST = 'feedback/';